import { Link } from 'react-router';
import LogoPng from '../../../assets/images/logo2.png';
import s from './HeaderMobile.module.scss';

const HeaderMobile = () => {
  return (
    <header className={s.header}>
      <Link className={s.link} to="/">
        <div className={s.logo}>
          <img src={LogoPng} alt="Логотип стоматологической клиники в Москве" />
        </div>
        <div className={s.text}>Стоматологическая клиника доктора Заремы</div>
      </Link>
    </header>
  );
};

export default HeaderMobile;
